import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import SolutionDetailPage from "./pages/SolutionDetailPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import EnrollPage from "./pages/EnrollPage";
import AboutPage from "./pages/AboutPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/solutions/:solutionId" element={<SolutionDetailPage />} />
        <Route path="/products/:productId" element={<ProductDetailPage />} />
        <Route path="/enroll/:courseId" element={<EnrollPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
